import { ReduxStore } from 'store/types';

function editIsLoading(state: ReduxStore): boolean {
  return state.product.edit.config.isLoading;
}

export default editIsLoading;
